<template>
    <!--visitSource  = 2 PC端-->
    <div v-if="visitSource == 2">
        <!-- 评分组件 -->
        <el-rate
                style="display: inline-block;margin-right: 10px"
                v-if="initDataInfo.RATE_NUM>=0"
                v-model="initDataInfo.RATE_NUM"
                disabled
                show-score
                text-color="#ff9900"
                score-template="{value}">
        </el-rate>
        <!-- 查看次数组件 -->

        <div v-if="(initDataInfo.LOOK_NUM>=0&&item.styleSet.isShowLook!=1)" style="display: inline-block;margin-right: 5px">
            <i class="el-icon-view" style="vertical-align: middle;"></i><span :style="'font-size:14px;color:#7a7a7a;vertical-align: middle;' + (item.styleSet.pageFieldLookStyleSet?item.styleSet.pageFieldLookStyleSet.styleSetCode:'')" kwName="pageFieldLookStyleSet">{{initDataInfo.LOOK_NUM}}次</span>
        </div>
        <!-- 购买次数组件 -->
        <div v-if="(initDataInfo.BUY_NUM>=0)" style="margin-right: 5px">
            <div v-if="(initPageSetInfo.listStyleSet.iconType)">
                <i class="el-icon-shopping-cart-2"></i>
                <span :style="'font-size:14px;color:#7a7a7a;'+ (item.styleSet.pageFieldBuyStyleSet?item.styleSet.pageFieldBuyStyleSet.styleSetCode:'')" kwName="pageFieldBuyStyleSet">{{initDataInfo.BUY_NUM}}</span>
            </div>
            <div v-else class="applyCourse_pc" :style="'font-size:14px;color:#7a7a7a;'+ (item.styleSet.pageFieldBuyStyleSet?item.styleSet.pageFieldBuyStyleSet.styleSetCode:'')" kwName="pageFieldBuyStyleSet">
                {{initDataInfo.BUY_NUM}}人已报名
            </div>
        </div>
        <!-- 收藏次数 -->

        <div v-if="(initDataInfo.COLLECT_NUM>=0&&item.styleSet.isShowStar!=1)" style="display: inline-block">
            <i class="el-icon-apple" style="vertical-align: middle;"></i>
            <span :style="'font-size:14px;color:#7a7a7a;vertical-align: middle;'+ (item.styleSet.pageFieldCollectionStyleSet?item.styleSet.pageFieldCollectionStyleSet.styleSetCode:'')" kwName="pageFieldCollectionStyleSet">{{initDataInfo.COLLECT_NUM}}</span>
        </div>

        <!-- 评论次数 -->
        <div v-if="(initDataInfo.PL_NUM>=0)">
            <i class="el-icon-apple"></i>
            <span :style="'font-size:14px;color:#7a7a7a;vertical-align: middle;'+ (item.styleSet.listFieldBuyStyleSet?item.styleSet.listFieldBuyStyleSet.styleSetCode:'')" kwName="listFieldBuyStyleSet">{{initDataInfo.PL_NUM}}</span>
        </div>
        <!-- 点赞次数 -->
        <div v-if="(initDataInfo.PRAISE_NUM>=0)">
            <i class="el-icon-apple"></i>
            <span :style="'font-size:14px;color:#7a7a7a;vertical-align: middle;'+ (item.styleSet.listFieldBuyStyleSet?item.styleSet.listFieldBuyStyleSet.styleSetCode:'')" kwName="listFieldBuyStyleSet">{{initDataInfo.PRAISE_NUM}}</span>
        </div>
    </div>


    <!--visitSource  = 3 移动端-->
    <div v-else>
        <!-- 评分组件 -->
        <el-rate
            style="display: inline-block;margin-right: 10px"
            v-if="initDataInfo.RATE_NUM>=0" 
            v-model="initDataInfo.RATE_NUM"
            disabled
            show-score
            text-color="#ff9900"
            score-template="{value}">
        </el-rate>
        <!-- 查看次数组件 -->

        <div v-if="(initDataInfo.LOOK_NUM>=0&&item.styleSet.isShowLook!=1)" style="display: inline-block;margin-right: 5px">
            <i class="el-icon-view" style="vertical-align: middle;"></i><span :style="'font-size:14px;color:#7a7a7a;vertical-align: middle;' + (item.styleSet.pageFieldLookStyleSet?item.styleSet.pageFieldLookStyleSet.styleSetCode:'')" kwName="pageFieldLookStyleSet">{{initDataInfo.LOOK_NUM}}次</span>
        </div>
        <!-- 购买次数组件 -->
        <div v-if="(initDataInfo.BUY_NUM>=0)" style="margin-right: 5px">
            <div v-if="(initPageSetInfo.listStyleSet.iconType)">
                <i class="el-icon-shopping-cart-2"></i>
                <span :style="'font-size:14px;color:#7a7a7a;'+ (item.styleSet.pageFieldBuyStyleSet?item.styleSet.pageFieldBuyStyleSet.styleSetCode:'')" kwName="pageFieldBuyStyleSet">{{initDataInfo.BUY_NUM}}</span>
            </div>
            <div v-else class="applyCourse" :style="'font-size:14px;color:#7a7a7a;'+ (item.styleSet.pageFieldBuyStyleSet?item.styleSet.pageFieldBuyStyleSet.styleSetCode:'')" kwName="pageFieldBuyStyleSet">
                {{initDataInfo.BUY_NUM}}人已报名
            </div>
        </div>
        <!-- 收藏次数 -->

        <div v-if="(initDataInfo.COLLECT_NUM>=0&&item.styleSet.isShowStar!=1)" style="display: inline-block">
            <i class="el-icon-apple" style="vertical-align: middle;"></i>
            <span :style="'font-size:14px;color:#7a7a7a;vertical-align: middle;'+ (item.styleSet.pageFieldCollectionStyleSet?item.styleSet.pageFieldCollectionStyleSet.styleSetCode:'')" kwName="pageFieldCollectionStyleSet">{{initDataInfo.COLLECT_NUM}}</span>
        </div>

        <!-- 评论次数 -->
        <div v-if="(initDataInfo.PL_NUM>=0)">
            <i class="el-icon-apple"></i>
            <span :style="'font-size:14px;color:#7a7a7a;vertical-align: middle;'+ (item.styleSet.listFieldBuyStyleSet?item.styleSet.listFieldBuyStyleSet.styleSetCode:'')" kwName="listFieldBuyStyleSet">{{initDataInfo.PL_NUM}}</span>
        </div>
        <!-- 点赞次数 -->
        <div v-if="(initDataInfo.PRAISE_NUM>=0)">
            <i class="el-icon-apple"></i>
            <span :style="'font-size:14px;color:#7a7a7a;vertical-align: middle;'+ (item.styleSet.listFieldBuyStyleSet?item.styleSet.listFieldBuyStyleSet.styleSetCode:'')" kwName="listFieldBuyStyleSet">{{initDataInfo.PRAISE_NUM}}</span>
        </div>
    </div>
</template>

<script>
import utils from '@/js/utils/util.js';
export default {
  name: 'kw_having_view',
  props: {
    initDataInfo: {
      type: Object,
      default: null
    },
    initPageSetInfo: {
      type: Object,
      default: null
    },
    item:{
      type: Object,
      default: null
    },
    previewVisitSource:{
      type:Number,
      default:0
    }
  },
  data() {
    var that = this;
    return {
        // 访问来源 PC:2 或者 H5:3
        visitSource:utils.checkVisitSource(that),
    };
  },
  created() {
    
  },
  mounted() {
    
  },
  watch:{
  },
  computed:{
  },
  components: {
  },
  methods: {
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.applyCourse{font-size: 14px;color:#A7A7A7;position:absolute;left:0;bottom:-15px}
.applyCourse_pc{font-size: 14px;color:#A7A7A7;position:absolute;left:0;bottom:-15px}
</style>
